/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * WELCHES FELD DER ZIELDATENBANK im Popup abgefragt wird — eines je
 * Zeile, in der Reihenfolge, in der sie im Formular stehen.
 * 
 * SEIT 24.09.2026 ZAEHLT NUR NOCH `feldId`. Betreiber: „Felder des
 * Formulars … nur Anzeigemodus … Inhalte kommen aus der
 * Datenfeldkonfiguration (Platzhalter aus Hinweis)." Beschriftung,
 * Platzhalter und Pflicht liest das Formular also am FELD der
 * Zieldatenbank:
 * 
 *   Beschriftung  Phrase, sonst Name des Feldes
 *   Platzhalter   `hinweis` des Feldes
 *   Pflicht       `required` des Feldes
 * 
 * Die drei Angaben unten bleiben im Schema, damit bestehende Baender
 * nicht stolpern; gelesen werden sie nicht mehr.
 * @export
 * @interface DatabaseNewsletterFeld
 */
export interface DatabaseNewsletterFeld {
    /**
     * Das Datenfeld der Zieldatenbank.
     * @type {string}
     * @memberof DatabaseNewsletterFeld
     */
    feldId?: string;
    /**
     * Was ueber dem Eingabefeld steht. Ohne Angabe steht dort der Name
     * des Datenfeldes.
     * @type {string}
     * @memberof DatabaseNewsletterFeld
     */
    beschriftung?: string;
    /**
     * Der graue Text im leeren Feld, etwa „name@beispiel.de".
     * @type {string}
     * @memberof DatabaseNewsletterFeld
     */
    platzhalter?: string;
    /**
     * Ohne Eintrag laesst sich das Formular nicht absenden. Der Stern
     * hinter der Beschriftung sagt es dem Gast.
     * @type {boolean}
     * @memberof DatabaseNewsletterFeld
     */
    pflicht?: boolean;
}

/**
 * Check if a given object implements the DatabaseNewsletterFeld interface.
 */
export function instanceOfDatabaseNewsletterFeld(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseNewsletterFeldFromJSON(json: any): DatabaseNewsletterFeld {
    return DatabaseNewsletterFeldFromJSONTyped(json, false);
}

export function DatabaseNewsletterFeldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseNewsletterFeld {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'feldId': !exists(json, 'feldId') ? undefined : json['feldId'],
        'beschriftung': !exists(json, 'beschriftung') ? undefined : json['beschriftung'],
        'platzhalter': !exists(json, 'platzhalter') ? undefined : json['platzhalter'],
        'pflicht': !exists(json, 'pflicht') ? undefined : json['pflicht'],
    };
}

export function DatabaseNewsletterFeldToJSON(value?: DatabaseNewsletterFeld | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'feldId': value.feldId,
        'beschriftung': value.beschriftung,
        'platzhalter': value.platzhalter,
        'pflicht': value.pflicht,
    };
}

